import { GET_MT_LIP_INVESTMENT } from '../../../actions/types';

const initialState = {
  mtLipInvest: []
};

const fetchMtLipInvestment = (state = initialState, action) => {
  switch (action.type) {
    case GET_MT_LIP_INVESTMENT:
      return {
        ...state,
        mtLipInvest: action.MtLip
      };
    default: return state;
  }
};

export default fetchMtLipInvestment;
